<!-- eslint-disable vue/no-v-html -->

<template>
  <div v-if="shouldShowWidget" class="card h-100 generic-text-widget">
    <div class="card-header">
      <h4 class="card-title">
        {{ widgetTitle }}
      </h4>
    </div>
    <div class="card-body">
      <div class="markdown-body" v-html="markdownBody"></div>
    </div>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it'

import commonWidgetProps from '@/components/mixins/common-widget-props'

export const genericTextWidgetInformation = () => {
  return {
    requests: {}
  }
}

export const genericTextWidgetSkeleton = () => {
  return {
    header: {
      height: 2
    },
    body: [
      {
        cols: [{ height: 2 }]
      },
      {
        cols: [{ height: 10 }]
      }
    ]
  }
}

const GenericTextWidget = {
  name: 'GenericTextWidget',
  mixins: [commonWidgetProps],
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      markdownIt: null
    }
  },
  // mounted() {
  //   this.markdownIt = new MarkdownIt()
  // },
  mounted() {
    // Create a new md instance
    this.markdownIt = new MarkdownIt()

    // Save reference to the default link renderer, if any
    const defaultRender =
      this.markdownIt.renderer.rules.link_open ||
      function (tokens, idx, options, env, self) {
        return self.renderToken(tokens, idx, options)
      }

    // Override link_open rule
    this.markdownIt.renderer.rules.link_open = function (
      tokens,
      idx,
      options,
      env,
      self
    ) {
      // Find the index of the 'target' attribute
      const aIndex = tokens[idx].attrIndex('target')

      if (aIndex < 0) {
        // Add new attribute
        tokens[idx].attrPush(['target', '_blank'])
        tokens[idx].attrPush(['rel', 'noopener noreferrer'])
      } else {
        // Replace existing target
        tokens[idx].attrs[aIndex][1] = '_blank'
      }

      // Pass token to default renderer
      return defaultRender(tokens, idx, options, env, self)
    }
  },
  computed: {
    enoughUsersInGroup() {
      const { maximumGroupMembers } = this.data.condition || {}
      const hasMaximumGroupMemberRequirement =
        Number.isInteger(maximumGroupMembers)
      return (
        !hasMaximumGroupMemberRequirement ||
        this.selectedGroup.numberOfUsers <= maximumGroupMembers
      )
    },
    markdownBody() {
      // TODO: sanitize html to prevent xss attack with something like DOMPurify
      return this.markdownIt?.render(
        this.$tr(this.data.locales, 'body.content')
      )
    },
    shouldShowWidget() {
      return this.enoughUsersInGroup
    },
    widgetTitle() {
      const givenName = this.userInfo.givenName
      return this.$tr(this.data.locales, 'header.title', givenName)
    }
  },
  methods: {
    markdownToHtml(text) {
      return md.render(text)
    }
  }
}

export default GenericTextWidget
</script>

<style lang="scss">
.markdown-body {
  font-size: 1.15rem !important;
  i {
    font-size: 1.15rem !important;
    color: inherit;
  }
  a {
    color: var(--kt-primary);
    text-decoration: underline;
  }
  a:hover {
    color: var(--kt-primary-active);
    text-decoration: underline !important;
  }
}
.markdown-body.feelgood-link a {
  color: var(--kt-link-color) !important;
  text-decoration: underline !important;
}
.markdown-body.feelgood-link a:hover {
  color: var(--kt-link-hover-color) !important;
}
</style>
